var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.6445C19.6211 24.6445 25.1055 19.1719 25.1055 12.5391C25.1055 5.91797 19.6211 0.433594 12.9883 0.433594C6.36719 0.433594 0.894531 5.91797 0.894531 12.5391C0.894531 19.1719 6.37891 24.6445 13 24.6445ZM13 14.4609C10.7031 14.4492 8.92188 12.5273 8.92188 9.99609C8.91016 7.60547 10.7148 5.61328 13 5.61328C15.2734 5.61328 17.0664 7.60547 17.0664 9.99609C17.0664 12.5273 15.2852 14.4844 13 14.4609ZM13 22.6641C10.375 22.6641 7.58594 21.5742 5.81641 19.6641C7.15234 17.6484 9.83594 16.4883 13 16.4883C16.1289 16.4883 18.8242 17.625 20.1719 19.6641C18.4023 21.5742 15.625 22.6641 13 22.6641Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonPassive);
export default __webpack_public_path__ + "static/media/icon-person-passive.ce25c5901f5cfa49974b046563bc1c60.svg";
export { ForwardRef as ReactComponent };